'use client'

import { Loader } from '@fukku/loader'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './Loading.module.scss'

export function Loading() {
	const { t } = useLabels()

	const accessibilityLoaderText = {
		loading: t('accessibility.loading.text'),
		loaded: t('accessibility.loading.text'),
	}

	return (
		<div className={styles.loading}>
			<Loader loading accessibilityText={accessibilityLoaderText} />
		</div>
	)
}
